import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Loader2, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full bg-transparent border-b border-white/20 py-3 text-white placeholder:text-white/30 focus:border-gold outline-none transition-colors";

  return (
    <div className="min-h-screen bg-ink flex flex-col items-center justify-center px-6" data-testid="admin-login-page">
      <div className="noise-overlay" />
      <Link to="/" className="absolute top-8 left-8 inline-flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors" data-testid="back-home">
        <ArrowLeft size={16} /> サイトへ戻る
      </Link>
      <div className="w-full max-w-sm">
        <img src="/prc-logo.png" alt="PRC Remit" className="h-14 w-14 object-contain mb-4" />
        <p className="font-display text-2xl font-extrabold tracking-tight text-white mb-1">PRC<span className="text-gold"> REMIT</span></p>
        <p className="text-sm text-white/40 mb-10">管理画面ログイン</p>
        <form onSubmit={submit} className="space-y-7" data-testid="login-form">
          <input data-testid="login-email" type="email" className={field} placeholder="メールアドレス" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input data-testid="login-password" type="password" className={field} placeholder="パスワード" value={password} onChange={(e) => setPassword(e.target.value)} required />
          {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-medium text-ink hover:bg-gold-light transition-colors disabled:opacity-60">
            {loading && <Loader2 size={16} className="animate-spin" />}
            ログイン
          </button>
        </form>
      </div>
    </div>
  );
}
